import {getCodeList} from 'country-list' 

export function GetCountries() {
  let countries = getCodeList();
  return countries;
}
